import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
// 测试服
// https://testvideochat.kissu.site
// 正式服
// https://videochat.kissu.site
// 创建axios实例
const service = axios.create({
  // baseURL: 'https://testvideochat.kissu.site', // api的base_url
  timeout: 60000,// 请求超时时间
  // 开发环境通过代理访问，不需要 withCredentials；生产环境需要发送 cookies
  withCredentials: true
})

// 判断是否在 App 内运行（与 Home.vue 中逻辑一致）
function isRunningInApp() {
  return navigator.userAgent.indexOf('quhongniubiManager') !== -1
}

// request拦截器
service.interceptors.request.use(
  (config) => {
    NProgress.start()
    if (sessionStorage.getItem('token')) {
      // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers.token = window.sessionStorage.getItem('token')
    } else if (window.$cookies && window.$cookies.get('token_kissu')) {
      config.headers.token = window.$cookies.get('token_kissu')
    }

    if (isRunningInApp() && typeof WebCallBack !== 'undefined') {
      var metaInfo = WebCallBack.getMateInfo()
      if (metaInfo) {
        var metaInfoObj = JSON.parse(metaInfo)
        // 将请求Header里传token，改成params传username和token
        if (metaInfoObj.token && metaInfoObj.username) {
          config.params = config.params
            ? {
              ...config.params,
              username: metaInfoObj.username,
              token: metaInfoObj.token,
            }
            : { username: metaInfoObj.username, token: metaInfoObj.token }
          console.log(metaInfoObj)
        }
      }
    }

    // 添加 channel 参数：如果 params 中不存在 channel，则添加 channel=googleplay_oari
    if (!config.params || !config.params.channel) {
      config.params = config.params
        ? { ...config.params, channel: 'googleplay_oari' }
        : { channel: 'googleplay_oari' }
    }

    // 如果是 POST 请求，body 中也要添加 channel（如果不存在）
    if (config.method && config.method.toLowerCase() === 'post') {
      if (!config.data) {
        config.data = {}
      }
      // 如果 data 是字符串（JSON），需要解析后添加
      if (typeof config.data === 'string') {
        try {
          const dataObj = JSON.parse(config.data)
          if (!dataObj.channel) {
            dataObj.channel = 'googleplay_oari'
            config.data = JSON.stringify(dataObj)
          }
        } catch (e) {
          // 解析失败，忽略（可能是 FormData 或其他格式）
        }
      } else if (typeof config.data === 'object' && !Array.isArray(config.data) && config.data !== null) {
        // data 是对象
        if (!config.data.channel) {
          config.data.channel = 'googleplay_oari'
        }
      }
    }

    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    NProgress.done()
    /**
     * code为非0是抛错 可结合自己业务进行修改
     */
    const res = response.data
    console.log('res===============>', response.config)

    // 针对 host_admin/channel/list 接口，过滤特定用户的响应数据
    if (response.config && response.config.url && response.config.url.includes('/channel/list')) {
      // username 存于 cookies（登录时写入 username_kissu），App 内嵌时可能从 sessionStorage 取
      const username = (window.$cookies && window.$cookies.get('username_kissu')) || window.sessionStorage.getItem('username')
      console.log('username===============>', username)
      // 如果用户名是 ZhongHua、Ean 或 Simon，过滤掉 value 不包含 oari 的项（只保留 value 包含 oari 的项）
      if (username && ['ZhongHua', 'Ean', 'Simon'].includes(username)) {
        if (res.code === 0 && Array.isArray(res.data)) {
          res.data = res.data.filter(item => {
            return (item.value && item.value.includes('oari'))
          })
          console.log(res.data)
          console.log(`用户 ${username} 的 channel/list 响应已过滤，只保留 value 包含 oari 的项`)
        }
      }
    }

    if (res.code !== 0) {
      // 1001:未登录;
      if (res.code === 1001) {
        // 防止重复弹出
        if (window.isRedirectingToLogin) {
          return Promise.reject(new Error('未登录，正在跳转到登录页'))
        }
        window.isRedirectingToLogin = true

        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            window.sessionStorage.clear()
            window.localStorage.removeItem('baseUrl')
            if (window.$cookies) {
              window.$cookies.remove('token_kissu')
              window.$cookies.remove('username_kissu')
            }
            window.location.href = '/#/login'
          })
          .catch(() => {
            window.sessionStorage.clear()
            window.localStorage.removeItem('baseUrl')
            if (window.$cookies) {
              window.$cookies.remove('token_kissu')
              window.$cookies.remove('username_kissu')
            }
            window.location.href = '/#/login'
          })
          .finally(() => {
            setTimeout(() => {
              window.isRedirectingToLogin = false
            }, 2000)
          })

        return Promise.reject(new Error('未登录，已跳转到登录页'))
      }
      return response
    } else {
      return response
    }
  },
  (error) => {
    NProgress.done()
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000,
    })
    return Promise.reject(error)
  }
)

export default service
